
import ChildWater from './components/child_water.js';
function App() {
  return (
    <div>
      <div className='background'>
      <div className='container'>
      
      <ChildWater/>
      </div>
      </div>

    </div>
  );
}

export default App;
